export const defaultTargetingAttributes = ['countryGuess', 'platform', 'app.platform'] as const

export type DefaultTargetingAttribute = (typeof defaultTargetingAttributes)[number]

export const additionalTargetingAttributes = ['namespace', 'subRegionGuess', 'deeplinkFlowType'] as const

export type AdditionalTargetingAttribute = (typeof additionalTargetingAttributes)[number]

export type TargetingAttribute = DefaultTargetingAttribute | AdditionalTargetingAttribute

export const targetBy = ['TRACKING_ID', 'CUSTOMER_TOKEN'] as const
export type TargetBy = (typeof targetBy)[number]

export type BaseTargetingInput = {
  defaultTargetingKey?: TargetBy
  extraAttributes?: readonly AdditionalTargetingAttribute[]
}

export type BaseTargeting = {
  defaultTargetingKey: TargetBy
  extraAttributes: readonly AdditionalTargetingAttribute[]
}

export type ManifestEntryWithTargeting = {
  targeting: BaseTargeting
}

export type ManifestTargetingRules<TManifest extends Record<string, ManifestEntryWithTargeting>> = {
  [K in keyof TManifest]: BaseTargeting
}

export const byCustomerToken = { defaultTargetingKey: 'CUSTOMER_TOKEN' } as const

export const normalizeTargeting = (input: BaseTargetingInput = {}): BaseTargeting => ({
  defaultTargetingKey: input.defaultTargetingKey ?? 'TRACKING_ID',
  extraAttributes: input.extraAttributes ?? [],
})

export const targetingRulesFromManifest = <TManifest extends Record<string, ManifestEntryWithTargeting>>(
  manifest: TManifest
): ManifestTargetingRules<TManifest> => {
  const rules = {} as ManifestTargetingRules<TManifest>

  for (const key of Object.keys(manifest) as Array<keyof TManifest>) {
    rules[key] = manifest[key].targeting
  }

  return rules
}
